<template lang='pug'>
v-card(flat)
  v-card-title
    v-layout(align-center)
      div(class='title') Клиент
      v-spacer
      v-btn(v-if='client' @click='$emit("unlink")' icon)
        v-icon link_off
      v-btn(v-else @click='$emit("link")' icon)
        v-icon link
  v-divider
  v-list(v-if='client' dense)
    v-list-tile
      v-list-tile-content(class='grey--text') Фамилия:
      v-list-tile-content(class='align-end') {{ client.second_name }}
    v-list-tile
      v-list-tile-content(class='grey--text') Имя:
      v-list-tile-content(class='align-end') {{ client.first_name }}
    v-list-tile
      v-list-tile-content(class='grey--text') Отчество:
      v-list-tile-content(class='align-end') {{ client.patronymic_name }}
    v-list-tile
      v-list-tile-content(class='grey--text') Должность:
      v-list-tile-content(class='align-end') {{ client.position }}
    v-list-tile
      v-list-tile-content(class='grey--text') Дата рождения:
      v-list-tile-content(class='align-end') {{ client.birthday | date }}
  v-list(v-else dense)
    v-list-tile
      v-list-tile-content(class='grey--text') Клиент не назначен
</template>

<script>
export default {
  props: {
    client: {
      type: Object
    }
  }
}
</script>
